import { render, staticRenderFns } from "./firstHome.vue?vue&type=template&id=5f1646fb&scoped=true&"
import script from "./firstHome.vue?vue&type=script&lang=js&"
export * from "./firstHome.vue?vue&type=script&lang=js&"
import style0 from "./firstHome.vue?vue&type=style&index=0&id=5f1646fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1646fb",
  null
  
)

export default component.exports